import { Action, Actions } from "./transferStatusActions";
import { TransferStatusState } from "./transferStatusState";

export default (state: typeof TransferStatusState, action: Action): typeof TransferStatusState => {
  switch (action.type) {
    case Actions.FETCHING_ROTH_TRANSFERRED_DESTINATIONS:
      return {
        ...state,
        fetchingRothTransferredDestinations: true,
      };

    case Actions.FETCHING_CURRENT_TRANSFER_INSTRUCTION:
      return {
        ...state,
        fetchingCurrentTransferInstruction: true,
      };

    case Actions.FETCHING_PROVIDER_MAILING_DETAILS:
      return {
        ...state,
        fetchingProviderMailingDetails: true,
      };

    case Actions.SET_CURRENT_TRANSFER_INSTRUCTION:
      return {
        ...state,
        currentTransferInstruction: action.payload.data,
        fetchingCurrentTransferInstruction: false,
        currentTransferInstructionFetched: true,
      };

    case Actions.GET_ROTH_TRANSFERRED_DESTINATIONS:
      return {
        ...state,
        rothTransferredDestinations: action.payload,
        rothTransferredDestinationsFetched: true,
        fetchingRothTransferredDestinations: false,
      };

    case Actions.CONNECT_DESTINATION_TO_TRANSFER:
      return {
        ...state,
        destinationConnectedToTransfer: true,
        connectingDestinationToTransfer: false,
      };

    case Actions.GET_PROVIDER_MAILING_DETAILS:
      return {
        ...state,
        providerMailingDetails: action.payload,
        fetchingProviderMailingDetails: false,
        providerMailingDetailsFetched: true,
      };

    case Actions.MAIL_CONFIRMED:
      return {
        ...state,
        mailConfirmed: true,
      };

    default:
      return state;
  }
};
